export default "__VITE_ASSET__F99KspPg__";